import { EVENTS } from '@/scripts/constants/css-classes'
import WCAG from '@/scripts/libs/wcag/wcag'

const outlineClassName = 'keyboard-navigation-active'

class FocusOutline {
  private addOutlineClass = (e: any) => {
    if (WCAG.isTabPressed(e)) {
      document.documentElement.classList.add(outlineClassName)
    }
  }

  private removeOutlineClass = () => {
    document.documentElement.classList.remove(outlineClassName)
  }

  init = () => {
    document.body.addEventListener(EVENTS.KEY_UP, this.addOutlineClass)
    document.body.addEventListener(EVENTS.MOUSE_MOVE, this.removeOutlineClass)
  }
  destroy = () => {
    document.body.removeEventListener(EVENTS.KEY_UP, this.addOutlineClass)
    document.body.removeEventListener(EVENTS.MOUSE_MOVE, this.removeOutlineClass)
  }
}

export default new FocusOutline()
